import React from 'react';
import { Link } from 'react-router-dom';
import './AppsTileList.scss';
import DynamicFaIcon from '../../components/DynamicFaIcon';

interface App {
    seo?: {
        tabTitle: string;
        title: string;
        description: string;
    };
    key: string;
    status: 'normal' | 'in_development' | 'new' | string;
    title: string;
    icon: string;
    credit?: string;
    appToken: string;
}

interface AppsTileListProps {
    apps: App[];
    loading: boolean;
    hospitalEnglishName?: string;
}

const AppStatus = ({ status }: { status: App['status'] }) => {
    if (status === 'inDevelopment') {
        return <div className="ribbon"><span>בפיתוח</span></div>;
    }
    if (status === 'new') {
        return <div className="ribbon"><span>חדש</span></div>;
    }
    return null;
};

// Actually we will enable training after repo migration & new asthma.
const IGNORED_APP_KEYS = ['PROTOCOLS', 'PAS', 'PASS', 'ASTHMA_SEVERITY', 'TRAINING', 'ANION_GAP', 'MEDS'];

const AppsTileList: React.FC<AppsTileListProps> = ({ apps, loading, hospitalEnglishName }) => {
    const hospitalPath = hospitalEnglishName || 'apps';

    if (loading) {
        return (
            <div className="apps-tile-list">
                {Array.from({ length: 8 }).map((_, index) => (
                    <div key={index} className="app-tile skeleton">
                        <div className="app-icon skeleton" />
                        <div className="app-title skeleton" />
                    </div>
                ))}
            </div>
        );
    }

    // Filter out ignored apps
    const filteredApps = apps.filter(app => !IGNORED_APP_KEYS.includes(app.key));

    return (
        <div className="apps-tile-list">
            {filteredApps.map((app) => (
                <Link
                    key={app.key}
                    to={`/main/${hospitalPath}/${app.appToken}`}
                    className="app-tile"
                >
                    <AppStatus status={app.status} />
                    <div className="app-icon">
                        <DynamicFaIcon iconName={app.icon} />
                    </div>
                    <div className="app-title">{app.title}</div>
                    {app.credit && <div className="app-credit">פותח בשיתוף  {app.credit}</div>}
                </Link>
            ))}
        </div>
    );
};

export default AppsTileList;